import * as React from "react";

import { Box } from "@mui/material";

import LoadingImg from '../../assets/images/loading.gif';

export default function LoadingIndicator() {
	return (
		<React.Fragment>
			<Box
				sx={{
					height: "100%",
					position: "absolute",
					width: "100%",
					zIndex: "999",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					background: "rgba(0,0,0,60%)",
                    flexDirection: "column",
                    color: 'white'
				}}
			>
				<img alt="loading" src={LoadingImg} />
			</Box>
		</React.Fragment>
	);
}
